<ngx-loading [show]="showSpinner" [config]="{ fullScreenBackdrop: true }"></ngx-loading>

          <div class="row mb-4">
            <div class="pull-left col-md-4 fromDate" style="margin-top: 15px;">
              <label><span class="redAtsrik">*</span>From Date </label>
              <p-datepicker [(ngModel)]="fromDate" [minDate]="startMinDate" [maxDate]="startMaxDate" [showIcon]="true"
                dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" [readonlyInput]="true" (onSelect)="onFromSelect($event)"
                appendTo="body"></p-datepicker>
            </div>
            <div class="col-md-5 toDate">
              <label><span class="redAtsrik">*</span>To Date </label>
              <p-datepicker [(ngModel)]="toDate" [minDate]="endMinDate" [maxDate]="endMaxDate" [showIcon]="true"
                dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" [readonlyInput]="true" [disabled]="disableToDate"
                (onSelect)="onToSelect($event)" appendTo="body"></p-datepicker>
              <button (click)="searchEncounter()" [disabled]="disableClaimsBtn"
                class="carelon-primary-btn claimsBtn" style="margin: 12px 8px 4px 19px;">Submit</button>
              <button (click)="clearDates()" [disabled]="disableClaimsBtn" class="carelon-primary-btn claimsBtn">Clear</button>
            </div>
          </div>
          <div>
            <p><b>View encounter summaries from Care Center visits below. You can select a date range of up to 6 months at a time.</b></p>
          </div>

<div class="clinical-details-container">
    @if (dataSource) {
      <div class="medication-details-table">
            <table mat-table [dataSource]="dataSource" matSort matSortActive="encounterdate" matSortDirection="desc"  class="mat-elevation-z8">
              <ng-container matColumnDef="encounterdate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 200px;">Encounter Date</th>
                <td class="cell-align-left" mat-cell *matCellDef="let med">{{med.encounterdate}}</td>
              </ng-container>
              <ng-container matColumnDef="encountertype">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 200px;">Encounter Type</th>
                <td class="cell-align-left" mat-cell *matCellDef="let med">{{med.encountertype}}</td>
              </ng-container>
              <ng-container matColumnDef="encountervisitname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Encounter Visit Name</th>
                <td class="cell-align-left" mat-cell *matCellDef="let med">{{med.encountervisitname}}</td>
              </ng-container>
              <ng-container matColumnDef="memberName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider Name</th>
                <td class="cell-align-left" mat-cell *matCellDef="let med">{{med.memberName}}</td>
              </ng-container>                                          
                                         
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Download</th>
                <td mat-cell *matCellDef="let med"><button (click)="download(med.encounterid,med.encounterdate,med.encountervisitname)"><img class="ESdwn" src="../../../assets/images/ESdownload.svg" alt="Download Icon" ></button></td>
              </ng-container>
            
              <ng-container *matNoDataRow>
                <tr>
                  <td class="noRecordAvailable" [attr.colspan]="displayedColumns.length"> No records available </td>
                </tr>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
            </mat-paginator>
          </div>
        }
      </div>